import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLocation({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a8 8 0 018 8c0 3.333-2.667 7.333-8 12-5.333-4.667-8-8.667-8-12a8 8 0 018-8zm0 2a6 6 0 00-6 6c0 2.363 1.955 5.515 6 9.304 4.045-3.788 6-6.941 6-9.304a6 6 0 00-6-6zm0 2a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLocation
